import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { from } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { CONDUCTORES_API_SERVER_ADDRESS, API_SERVER_ADDRESS } from '../../environments/environment';
import { AuthenticationService } from '../_services/authentication.service';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  // Intentar obtener el token del BehaviorSubject
  let currentToken = authService.currentTokenSubject.value;

  if (currentToken) {
    // Si ya hay token, sigue normal
    const isApiUrl =
      req.url.startsWith(CONDUCTORES_API_SERVER_ADDRESS)
      || req.url.startsWith(API_SERVER_ADDRESS);

    if (isApiUrl) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${currentToken}`
        }
      });
    }
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token caducado o inválido, hacer logout automático
          authService.logout().then(() => {
            router.navigate(['/login']);
          });
        }
        return throwError(() => error);
      })
    );
  } else {
    // Si no hay token, intenta obtenerlo del storage (asíncrono)
    return from(authService.getToken()).pipe(
      switchMap((token) => {
        if (token && (req.url.startsWith(CONDUCTORES_API_SERVER_ADDRESS) || req.url.startsWith(API_SERVER_ADDRESS))) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }
        return next(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              // Token caducado o inválido, hacer logout automático
              authService.logout().then(() => {
                router.navigate(['/login']);
              });
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
};
